import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { RequestHelper } from '../../../infrastructure/core/requestHelper';
import { Voucher } from '../../../models/DTO/vouchers/voucher';
import { CreateVoucherRequestModel } from '../../../models/requestModels/vouchers/createVoucherRequestModel';

@Injectable({
  providedIn: 'root'
})
export class VouchersService {

  private vouchersURL = Config.api + "voucher";
  private getActiveVouchersURL = Config.api + "voucher?filter[state]=pending";


  constructor(private http: HttpClient) { }

  createVoucher(cretedVoucher: CreateVoucherRequestModel) {
    return this.http.post<void>(this.vouchersURL, cretedVoucher);
  }

  getVouchersForUser() {
    return this.http.get<Voucher>(this.getActiveVouchersURL);
  }

  deleteVoucher(voucherId: number) {
    const params = RequestHelper.addRESTParams([
      voucherId.toString()
    ])

    return this.http.delete<void>(this.vouchersURL + params);
  }
}
